import dayjs from 'dayjs';
import http from '@os-web/http';
import { Cache, getChannel, PromiseWithResolvers, sleep } from '@os-web/utils';

const { promise, resolve } = PromiseWithResolvers<number>();
let isGet = false;

const tfPayCountCache = new Cache<number>('payCount');

export function setTfPay() {
  const count = tfPayCountCache.get() || 0;
  tfPayCountCache.set(count + 1, dayjs().add(1, 'y').valueOf());
}

async function getFingerStatus(retry = 3): Promise<boolean> {
  try {
    const res = await http.get<{ is_old?: boolean }>('/api/comm/browser/is_old', undefined, {
      timeout: 5000,
    });
    return !!res?.is_old;
  } catch (error) {
    console.error(error);
  }

  if (retry <= 0) return false;

  await sleep(1000);
  return getFingerStatus(retry - 1);
}

async function includeOldUserTfChannel(retry = 3): Promise<boolean> {
  const channel = getChannel();

  try {
    const res = await http.get<{ status?: string }>('/api/comm/on_off', {
      key: 'old_user_tf_channel',
    });

    if (res?.status) {
      return res.status.split(',').includes(String(channel));
    }
  } catch (error) {
    console.error(error);
  }

  if (retry <= 0) return false;
  return includeOldUserTfChannel(retry - 1);
}

export async function isRegularCustomer() {
  if (isGet) return promise;
  isGet = true;

  const fingerStatus = await getFingerStatus();

  if (!fingerStatus && !tfPayCountCache.get()) {
    resolve(0);
    return promise;
  }

  setTfPay();

  const isOldUserChannel = await includeOldUserTfChannel();
  resolve(isOldUserChannel ? 1 : 0);
  return promise;
}
